import React, { useState } from 'react';
import './App.css';
import Loader from './components/Loader/Loader.jsx';
import StartMenu from './components/StartMenu/StartMenu';
import NavbarGame from './components/NavbarGame/NavbarGame';
import InfoPage from './components/InfoPage/InfoPage';
import GamePage from './components/GamePage/GamePage';
import FinishGame from './components/FinishGame/FinishGame';
import textContents from './data/dataInterface';

let imagesName = {};
let imagesArr = {}; //массив с картиноками, ключ - название картинки
let rightPlace = [];
let rightAnswers = [];
let langv = 'rus';
let isLoad = false;

function rightWrongPlace() {  //делаем случайным положение правильного ответа
    rightPlace = [];
    rightAnswers = [];
    for(let i = 0; i < imagesName.length; i++) {
        rightPlace.push(Math.floor(Math.random() * 2));
        rightAnswers.push(0);
    }
};

function GameContent(content, callback) { 
    imagesName = Object.keys(content);
         
   for(let id of imagesName) {                 //чтение в кэш картинок контента, ключ - название картинки
        
    let urlFile = process.env.PUBLIC_URL +'/content/' + id + '.png';
        imagesArr[id] = new Image(550,315);
        imagesArr[id].src = urlFile;
      };
        imagesArr['bgGame'] = new Image(695,594);
        imagesArr['bgGame'].src = process.env.PUBLIC_URL + '/interface/bgGame.png';

          
        imagesArr['bgInfo'] = new Image(695,594);
        imagesArr['bgInfo'].src = process.env.PUBLIC_URL + '/interface/bgInfo.png';

        imagesArr['bgImg'] = new Image(695, 594);
        imagesArr['bgImg'].src = process.env.PUBLIC_URL + '/interface/bgImg.png';

        imagesArr['bgStart'] = new Image(700, 650);
        imagesArr['bgStart'].src = process.env.PUBLIC_URL + '/interface/bgStart.png';

        shuffle(imagesName);  //перемешиваем массив слов-картинок, в этом порядке будет идти текущая игра
    callback();
};

function readData() { //чтение данных 
    let address = window.top.document.location.href; //определение языка на котором находится игра
    if (address.indexOf('/fin/') > 0) langv = 'fin';
   
    GameContent(textContents.content, function() { isLoad = true; });
 };

readData();

//Функции перемешивания масива

//вспомогательная функция
function putToCache(elem, cache){
	if(cache.indexOf(elem) !== -1){
		return;
	}
	var i = Math.floor(Math.random()*(cache.length + 1));
	cache.splice(i, 0, elem);
}
//функция, возвращающая свеженький, девственный компаратор
function madness(){
	var cache = [];
	return function(a, b){
		putToCache(a, cache);
		putToCache(b, cache);
		return cache.indexOf(b) - cache.indexOf(a);
	};
}
//собственно функция перемешивания
function shuffle(arr){
	var compare = madness();
	return arr.sort(compare);
};

  
export default function App()  {
    const [isNewImg, setIsNewImg] = useState(1); 
    const [lang, setLang] = useState(langv);
    const [start, setStart] = useState(true);
    const [info, setInfo] = useState(false);
    const [step, setStep] = useState(0);
    const [imgId, setImgId] = useState(1);
    const [rightButton, setRightButton] = useState(0); //местоположение правильного ответа
    const [disabled, setDisabled] = useState(false);  // ответ нажат, кнопки не активны
    const [rightAnswer, setRightAnswer] = useState(rightAnswers); //массив с указанием состояния ответа: 0 - еще нет ответа, 1 - ответ верен, 2 - ответ неверен 
    const [finish, setFinish] = useState(false); //конец игры
    const [isLoading, setIsLoading] = useState(false);

    const preloadTime = (() => {
       setIsLoading(isLoad);
       if (isLoad) clearInterval(timerId);
    });
 
    let timerId = setInterval(preloadTime, 3000);
     
   const handleComponent =((pri) => {
       if (pri === 'rus' && lang === 'fin') {
           setLang('rus');
       };
       if(pri === 'fin' && lang === 'rus') {
           setLang('fin');
        }
        if (pri==='start') {
            shuffle(imagesName);
            rightWrongPlace();
            setStart(!start);
            setRightAnswer(rightAnswers);
            setInfo(true);
            setStep(0);
            setImgId(imagesName[0]);
            setRightButton(rightPlace[0]);
        }
        if (pri==='toStart') {
            shuffle(imagesName);
            rightWrongPlace();
            setStart(!start);
            setInfo(false);
            setStep(0);
            setImgId(imagesName[0]);
            setRightButton(rightPlace[0]);
            setRightAnswer(rightAnswers);
            setDisabled(false);
            setFinish(false);
        }; 
            if (pri==='continue') {
            setInfo(false);
        }; 
            if (pri==='info') {
            setInfo(true);
        }; 
 
        if (pri==='next' && step < imagesName.length -1 ) {
            setIsNewImg(step +1);
            setStep(step + 1);
            setImgId(imagesName[step + 1]);
            setRightButton(rightPlace[step + 1]);
            setDisabled(false); 
        }
        if (pri==='next' && step === imagesName.length -1 ) {
            setFinish(true);
            setStep(0); 
        };
        if (pri==='wrong') {
            setIsNewImg(0);
            rightAnswer[step] = 2;
            setDisabled(true);
            setRightAnswer(rightAnswer);
        }
        if (pri==='answer') {
            setIsNewImg(0);
            rightAnswer[step] = 1;
            setDisabled(true);
            setRightAnswer(rightAnswer);
       }
       
    }); 

  return (
    <div className='App'>
      <div className='App-header'>
              {!isLoading ? <Loader /> : null}
              {(start && isLoading) ? (<StartMenu lang={lang} onClick={(pri) => handleComponent(pri)} startPage={textContents.startPage} src={imagesArr['bgStart'].src}  />) : null}
              {(!start && isLoading) ? <NavbarGame lang={lang} onClick = {(pri) => handleComponent(pri)} topMenu = {textContents.topMenu} src={imagesArr['bgGame'].src} /> : null }
              {(info && isLoading) ? <InfoPage lang={lang} onClick = {(pri) => handleComponent(pri)} textGame = {textContents.textGame} src={imagesArr['bgInfo'].src}/> : null }

   {(!info && !start && isLoading) ? 
                  (!finish ? <GamePage step={step} disabled={disabled} content={textContents.content} imgId={imgId} lang={lang} src={imagesArr[imgId].src} bgSrc={imagesArr.bgImg.src}  rightButton={rightButton} onClick={(pri) => handleComponent(pri)} rightAnswer={rightAnswer} NewImg={isNewImg} /> : <FinishGame lang={lang}  onClick = {(pri) => handleComponent(pri)} rightAnswer = {rightAnswer} textGame = {textContents.textGame} />) : null }  
      </div>
      
    </div>
  );
};